import {
  endOfMonth,
  endOfYear,
  format,
  isLeapYear,
  startOfYear,
} from "date-fns"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function periodOfDays(
  dateRange: string,
  selectedYear?: $TSMigrationFixMe
) {
  const generateDate = ({
    addMonth,
    subsMonth,
    month,
    day,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) =>
    format(
      new Date(
        selectedYear,
        !month
          ? addMonth
            ? (new Date().getMonth() + addMonth, day)
            : (new Date().getMonth() - subsMonth, day)
          : month,
        day
      ),
      "yyyy-MM-dd"
    )

  const datesObjectRange: {
    [key: string]: { startDate: string; endDate: string }
  } = {
    YEAR: {
      startDate: format(
        startOfYear(new Date(selectedYear, 0, 1)),
        "yyyy-MM-dd"
      ),
      endDate: format(endOfYear(new Date(selectedYear, 0, 1)), "yyyy-MM-dd"),
    },
    FIRST_TRIMESTER: {
      startDate: format(
        startOfYear(new Date(selectedYear, 0, 1)),
        "yyyy-MM-dd"
      ),
      endDate: generateDate({ month: 2, day: 31 }),
    },
    SECOND_TRIMESTER: {
      startDate: generateDate({ month: 3, day: 1 }),
      endDate: generateDate({ month: 5, day: 30 }),
    },
    THIRD_TRIMESTER: {
      startDate: generateDate({ month: 6, day: 1 }),
      endDate: generateDate({ month: 8, day: 30 }),
    },
    FOURTH_TRIMESTER: {
      startDate: generateDate({ month: 9, day: 1 }),
      endDate: generateDate({ month: 11, day: 31 }),
    },
    JANUARY: {
      startDate: format(
        startOfYear(new Date(selectedYear, 0, 1)),
        "yyyy-MM-dd"
      ),
      endDate: format(endOfMonth(new Date(selectedYear, 0, 1)), "yyyy-MM-dd"),
    },
    FEBRUARY: {
      startDate: generateDate({ month: 1, day: 1 }),
      endDate: generateDate({
        month: 1,
        day: isLeapYear(new Date(selectedYear, 8, 1)) ? 29 : 28,
      }),
    },
    MARCH: {
      startDate: generateDate({ month: 2, day: 1 }),
      endDate: generateDate({ month: 2, day: 31 }),
    },
    APRIL: {
      startDate: generateDate({ month: 3, day: 1 }),
      endDate: generateDate({ month: 3, day: 30 }),
    },
    MAY: {
      startDate: generateDate({ month: 4, day: 1 }),
      endDate: generateDate({ month: 4, day: 31 }),
    },
    JUNE: {
      startDate: generateDate({ month: 5, day: 1 }),
      endDate: generateDate({ month: 5, day: 30 }),
    },
    JULY: {
      startDate: generateDate({ month: 6, day: 1 }),
      endDate: generateDate({ month: 6, day: 31 }),
    },
    AUGUST: {
      startDate: generateDate({ month: 7, day: 1 }),
      endDate: generateDate({ month: 7, day: 31 }),
    },
    SEPTEMBER: {
      startDate: generateDate({ month: 8, day: 1 }),
      endDate: generateDate({ month: 8, day: 30 }),
    },
    OCTOBER: {
      startDate: generateDate({ month: 9, day: 1 }),
      endDate: generateDate({ month: 9, day: 31 }),
    },
    NOVEMBER: {
      startDate: generateDate({ month: 10, day: 1 }),
      endDate: generateDate({ month: 10, day: 30 }),
    },
    DECEMBER: {
      startDate: generateDate({ month: 11, day: 1 }),
      endDate: generateDate({ month: 11, day: 31 }),
    },
  }

  return {
    min: datesObjectRange?.[dateRange]?.startDate,
    max: datesObjectRange?.[dateRange]?.endDate,
  }
}
